import { render, staticRenderFns } from "./RolePageDel.vue?vue&type=template&id=1bf3fd1a&scoped=true&"
import script from "./RolePageDel.vue?vue&type=script&lang=js&"
export * from "./RolePageDel.vue?vue&type=script&lang=js&"
import style0 from "./RolePageDel.vue?vue&type=style&index=0&id=1bf3fd1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf3fd1a",
  null
  
)

export default component.exports